export default {
    ACCEPT_OFFER: "acceptOffer",
    FINISH_APPLY: "finishApply",
    PATCH: "patch",
    RESTART_APPLY: "restartApply",
    RESUME: "resume",
    RESUME_CASCADE_ACTION: "resume_cascade_action",
    START_APPLY: "startApply",
    SUBMIT_ANSWERS: "submitAnswers",
    SUBMIT_COMPLETE: "submitComplete",
    SUBMIT_ESIGN: "submitEsign",
    SELECT_PAYMENT_PLAN: "selectPaymentPlan",
    SUBMIT_BANK_ACCOUNT: "submitBankAccount",
    SUBMIT_BANK_CARD: "submitBankCard",
    SUBMIT_FULL_APPlY: "submitFullApply",
    SUBMIT_PREQUALIFLY: "submitPrequalify",
    SUBMIT_PRESCREEN: "submitPrescreen",
}
